import { useCourseCategories } from 'src/common/hooks/useCommonCourseCategories';
import { useSelector } from 'react-redux';
import { courseListingSelectedCategoriesSelector } from 'src/state/courseListing/courseListingSelectors';
import { useMemo } from 'react';

export function useActiveCourseCategoryFilter() {
  const { data } = useCourseCategories();

  const selectedCategoryIds = useSelector(courseListingSelectedCategoriesSelector);

  return useMemo(
    () => (data ? data.filter(({ id }) => selectedCategoryIds[id]) : []),
    [data, selectedCategoryIds],
  );
}
